// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bik_j bik_i bik_bc bik_r bik_st","QualityCheckboxes__quality":"ex_b"};